<template>
  <px-custom-dialog v-model="dialog" content-class="rounded-card" width="1280">
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      Detalhes da resposta
      <v-btn class="ml-3" icon link target="_blank" :to="linkCotacao">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
    <template>
      <px-resposta-detalhes is-modal-view
                            :cotacao-id-prop="cotacaoId"
                            :resposta-id-prop="respostaId" />
    </template>
  </px-custom-dialog>
</template>

<script>
import RespostaDetalhes from '@/modules/cotacao/resposta/detalhes/RespostaDetalhes.vue';

export default {
  props: {
    cotacaoId: {
      type: [String, Number],
    },
    respostaId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    linkCotacao() {
      return `/cotacao/${this.cotacaoId}/respostas/${this.respostaId}`;
    },
  },
  components: {
    pxRespostaDetalhes: RespostaDetalhes,
  },
};
</script>
